import { IconType } from "react-icons";


interface IconComponentProps {
  icon: IconType;
  size?: number | string;
  color?: string;
  className?: string;
}

const IconComponent: React.FC<IconComponentProps> = ({ icon: Icon, size = 24, color = "inherit", className }) => {
  return <Icon size={size} color={color} className={className} />;
};

export default IconComponent;